<script setup>
import { ColorPicker } from "vue3-colorpicker"
import "vue3-colorpicker/style.css"

const props = defineProps({
    modelValue: {
        type: String
    },
    inputClass: {
        type: String
    },
})

const emit = defineEmits(['update:modelValue'])

const set = (value) => {
    emit('update:modelValue', value)
}
</script>

<template>
    <!-- <div>{{ props.modelValue }}
        <div class="w-6 h-6 rounded-full" :class="props.inputClass" :style="`background-color: ${props.modelValue}`"></div>
        <input type="color" class="inputClass" v-model="props.modelValue" @input="set($event.target.value)">
    </div> -->
    <ColorPicker :class="props.inputClass" v-model:pureColor="props.modelValue" @update:pureColor="set" shape="circle"
        pickerType="chrome" :disableHistory="true" :disableAlpha="true" format="hex">
    </ColorPicker>
</template>



<style>
.vc-current-color.vc-transparent,.vc-input-toggle{
    display: none !important;
}
</style>